const WORD_JOINER = '\u2060';
const ZERO_WIDTH_NON_JOINER = '\u200C';
// the likelihood of these two characters occurring adjacently in user text is almost zero.
const REDACT_OPEN = `${WORD_JOINER}${ZERO_WIDTH_NON_JOINER}`;
const REDACT_CLOSE = `${ZERO_WIDTH_NON_JOINER}${WORD_JOINER}`;
const REDACT_PATTERN = new RegExp(`${REDACT_OPEN}(.*?)${REDACT_CLOSE}`, 'gs');
const REDACTED = '[REDACTED]';

/** wraps a string in invisible characters to tell {@link redact} to redact it before sending the text to Sentry. */
export const needsRedact = (text: string) =>
  `${REDACT_OPEN}${text}${REDACT_CLOSE}`;

/**
 * @param text a string which potentially has been marked up by {@link needsRedact}
 * @returns the input text, with redacted blocks cleaned out and replaced with {@link REDACTED [REDACTED]}
 */
export const redact = (text: string) => text.replace(REDACT_PATTERN, REDACTED);
